import { PublishStatus } from "src/app/modules/PulseLeads/pages/Engagement/EngagementTopic/Detail/utils";
import TargetAgent from '../../../../PulseLeads/pages/Rule/ActivityPoint/PointRuleSettings/Detail/TargetAgent/index';
export interface completeMessage {
  title: string;
  content: string;
}

export interface AutoAddSettingProps {
  isAutoAddLead: boolean;
  triggerAction?: string | unknown;
  leadSource?: string | unknown;
  leadDescription?: string;
}

export type CustomerSurveyFormState = {
  startDate: Date | null;
  endDate: Date | null;
  consents: string[];
  body?: Record<string, unknown>;
  numberofTnc: number;
  completeMessage: completeMessage;
  surveyImage?: string;
  bannerId: string;
  status: string;
  flyerMessage: string;
  enableTargetAgents: boolean;
  targetAgents?: Array<{ agentCode: string }>;
  autoAddSetting: AutoAddSettingProps;
};

export const CustomerinitialState: CustomerSurveyFormState = {
  startDate: null,
  endDate: null,
  consents: [],
  body: undefined,
  numberofTnc: 1,
  completeMessage: {
    title: "",
    content: "",
  },
  surveyImage: undefined,
  bannerId: "",
  status: PublishStatus.Draft.key,
  flyerMessage: "",
  enableTargetAgents: false,
  targetAgents: [],
  autoAddSetting: {isAutoAddLead: false, triggerAction:"", leadSource: "", leadDescription: ""},
};

export type ModifyFieldAction = {
  type: "MODIFY_FIELD";
  payload: {
    field: keyof CustomerSurveyFormState;
    value: any;
  };
};

export type ModifyCompleteMessageAction = {
  type: "MODIFY_COMPLETE_MESSAGE";
  payload: {
    field: keyof CustomerSurveyFormState;
    subField: any;
    value: any;
  };
};

export type CustomerSurveyErrorState = {
  mandatory: {
    startDate: boolean;
    endDate: boolean;
    body: boolean;
    triggerAction?: boolean;
    leadSource?: boolean;
    leadDescription?: boolean;
  };
  immediate: {
    endDateBeforeStartDate: boolean;
    flyerMessage: boolean;
  };
};
